<template>
    <div v-show="show" class="bg">
        <input style="position: absolute; top: -100000000000px" ref="wordList" type="text">
        <div class="box-container">
            <div class="title">
                <img src="@assets/img/mediaPublish/warning.png" alt="">
                <p>分享链接生成成功</p>
            </div>
            <div class="input">
                <p>{{share_url}}</p>
                <span>链接将在<i>一小时</i>后失效</span>
            </div>
            <div class="btns">
                <span v-if="iscopy">复制链接成功</span>
                <p @click="iscopy = true;copyText()" class="btn on">复制链接</p>
                <p @click="close" class="btn">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
    import common from "@common/common";
    import { apis } from "@common/config";
    export default {
        data() {
            return {
                show: true,
                id: '',
                share_url: '',
                iscopy: false
            }
        },
        methods: {
            copyText() {
                const wordListDom = this.$refs.wordList;
                wordListDom.value = this.share_url;
                wordListDom.select();
                // 执行浏览器复制命令
                document.execCommand("Copy");
                // this.$toast("复制成功");
            },
            open(id) {
                this.id = id
                this.show = true
                this.getShareUrl()
            },
            close() {
                this.show = false
            },
            getShareUrl() {
                const info = {
                    id: this.id
                };
                common.myFetch(apis.newMediaPlatformShare, info).then(r => {
                    if (r) {
                        this.share_url = r.share_url
                        console.log(r)
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(50, 59, 75, 0.3);
    border-radius: 2px;
    backdrop-filter: blur(1.6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1008;

    .box-container {
        width: 558px;
        height: 214px;
        padding: 32px 32px 24px;
        background: #F9F9F9;
        box-sizing: border-box;

        .title {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 14px;

            img {
                width: 22px;
                height: 22px;
                margin-right: 16px;
            }

            p {
                font-size: 16px;
                line-height: 24px;
                color: #323B4B;
                font-weight: bold;
            }
        }

        .input {
            position: relative;
            height: 32px;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;

            p {
                width: 456px;
                height: 32px;
                line-height: 32px;
                font-size: 14px;
                font-weight: 500;
                background: rgba(185, 195, 195, 0.2);
                border-radius: 4px;
                padding: 0 20px;
                box-sizing: border-box;
                color: #323B4B;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            span {
                position: absolute;
                bottom: -32px;
                left: 38px;
                font-size: 14px;
                line-height: 22px;
                color: #323B4B;
                font-weight: bold;

                i {
                    color: #41B48C;
                }
            }
        }

        .btns {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            margin-top: 56px;

            span {
                position: absolute;
                top: -26px;
                right: 80px;
                font-size: 14px;
                font-weight: 500;
                color: #41B48C;
                line-height: 22px;
            }

            .btn {
                user-select: none;
                cursor: pointer;
                width: 65px;
                height: 32px;
                line-height: 32px;
                color: #FFF;
                text-align: center;
                background: #B9C3C3;
                border-radius: 4px;
            
                &.on {
                    width: 100px;
                    height: 32px;
                    background: #41B48C;
                    margin-right: 8px;
                }
            }
        }
    }
}
</style>